import { render, staticRenderFns } from "./ui-reward-trigger-dropdown.vue?vue&type=template&id=fbb409cc"
import script from "./ui-reward-trigger-dropdown.vue?vue&type=script&lang=ts"
export * from "./ui-reward-trigger-dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports